(function (Drupal, $) {
  'use strict';

  // Create new slider with arrows and progress bar.
  const Slider = function (slider) {
    this.slider = slider.querySelector('.tv-slider-items');
    this.slides = this.slider.querySelectorAll('.tv-slider-item');
    this.currentSlide = 0;
    this.container = null;
    this.breakpoints = [
      { "breakpoint": 0, "slidesToShow": 1 },
      { "breakpoint": 768, "slidesToShow": 2 },
      { "breakpoint": 1200, "slidesToShow": 3 },
    ];
    this.slidesToShow = this.breakpoints[0].slidesToShow;

    this.addProgressBarAndArrows();
    this.updateProgressBar();
    this.addEventListeners();
    this.init();
    this.slider.classList.add('ready');
  };

  Slider.prototype.init = function () {
    this.updateSlidesToShow();
  };

  Slider.prototype.updateSlidesToShow = function () {
    const width = window.innerWidth;
    let slidesToShow = 1;
    this.breakpoints.forEach(function (breakpoint) {
      if (width >= breakpoint.breakpoint) {
        slidesToShow = breakpoint.slidesToShow;
      }
    });

    this.slidesToShow = slidesToShow;
    this.updatePosition();
  };

  Slider.prototype.updatePosition = function () {
    const slideWidth =  this.slides[0].offsetWidth;
    this.slider.style.transform = 'translateX(' + (-this.currentSlide * this.slidesToShow * slideWidth) + 'px)';

    if (!this.container) {
      return;
    }

    const arrows = this.container.querySelectorAll('.tv-arrow');
    if (this.currentSlide <= 0) {
      arrows[0].classList.add('disabled');
    }
    else {
      arrows[0].classList.remove('disabled');
    }
    if ((this.currentSlide + 1) * this.slidesToShow >= this.slides.length) {
      arrows[1].classList.add('disabled');
    }
    else {
      arrows[1].classList.remove('disabled');
    }

    this.updateProgressBar();
  };

  Slider.prototype.addEventListeners = function () {
    this.container.addEventListener('click', function (e) {
      if (e.target.classList.contains('tv-arrow') && !e.target.classList.contains('disabled')) {
        this.handleArrowClick(e.target);
      }
    }.bind(this));

    window.addEventListener('resize', function () {
      this.currentSlide = 0;
      this.updateSlidesToShow();
    }.bind(this));
  };

  Slider.prototype.handleArrowClick = function (arrow) {
    if (arrow.classList.contains('next')) {
      this.goToNextSlide(arrow);
    } else {
      this.goToPrevSlide(arrow);
    }
  };

  Slider.prototype.goToNextSlide = function (arrow) {
    this.currentSlide++;
    if ((this.currentSlide + 1) * this.slidesToShow >= this.slides.length) {
      arrow.classList.add('disabled');
    }
    this.updatePosition();
  };

  Slider.prototype.goToPrevSlide = function (arrow) {
    this.currentSlide--;
    if (this.currentSlide <= 0) {
      arrow.classList.add('disabled');
    }
    this.updatePosition();
  };

  Slider.prototype.addProgressBarAndArrows = function () {
    this.container = document.createElement('div');
    this.container.classList.add('tv-slider-container', 'mt-4', 'd-flex', 'justify-content-between', 'align-items-center');

    const progressBar = document.createElement('div');
    progressBar.classList.add('tv-progress-bar', 'w-100', 'me-3');
    const progress = document.createElement('div');
    progress.classList.add('tv-progress');
    progressBar.appendChild(progress);

    this.container.appendChild(progressBar);

    const next = document.createElement('div');
    const counter = document.createElement('div');
    const prev = document.createElement('div');
    prev.classList.add('tv-arrow', 'prev');
    counter.classList.add('counter', 'tk-factoria', 'fw-bold', 'text-uppercase', 'text-center');
    next.classList.add('tv-arrow', 'next');
    this.container.appendChild(prev);
    this.container.appendChild(counter);
    this.container.appendChild(next);

    this.slider.parentNode.insertBefore(this.container, this.slider.nextSibling);
  };

  Slider.prototype.updateProgressBar = function () {
    const slideWidth =  this.slides[0].querySelector('.wrapper-tv_product_slider_item').offsetWidth;
    const progress = this.container.querySelector('.tv-progress');
    const progressPercent = 1 / Math.ceil(this.slides.length / this.slidesToShow) * 100;
    progress.style.width = progressPercent + '%';
    progress.style.left = (this.currentSlide / Math.ceil(this.slides.length / this.slidesToShow) * 100) + '%';

    const counter = this.container.querySelector('.counter');
    counter.innerHTML = this.currentSlide + 1 + '/' + Math.ceil(this.slides.length / this.slidesToShow);

    this.container.style.width = slideWidth + 'px';
  };

  /**
   * TV Slider handler.
   *
   * @type {{attach: Drupal.sticky_bar.attach}}
   */
  Drupal.behaviors.tv_slider = {
    attach: function (context, settings) {

      once('tv-slider', '.paragraph--type--tv-product-slider .field--name-field-tv-items').forEach(function (element) {
        new Slider(element);
      });
    }
  };

} (Drupal, jQuery));
